/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.SystemVersions {

    export interface ISystemVersionsContext {
        activate(): void;
    }

    export class SystemVersionInfo {
        public LibraryName: string;
        public Version: string;
        public VersionDate: Date;
    }

    export class SystemVersionsContext implements ISystemVersionsContext {

        protected SystemVersionInfo: SystemVersionInfo[];

        constructor(protected appSettings: Meevo.Components.Common.IAppSettings,
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            protected busyService: Meevo.Components.Busy.IBusyService) {
        }

        activate(): void {
            this.loadVersions()
                .then((data: SystemVersionInfo[]) => {
                    this.SystemVersionInfo = data;
                });
        }

        loadVersions(): ng.IPromise<SystemVersionInfo[]> {
           
                this.busyService.start();

            return this.dataService.customMethodData('/api/' + this.appSettings.API_ENDPOINTS.systemVersions, 'Get', {})
                .then(result => {
                    let arrayResult: Array<SystemVersionInfo> = [];

                    for (const m in result.data) {
                        arrayResult.push({
                            LibraryName: m,
                            Version: result.data[m].version,
                            VersionDate: result.data[m].versionDate
                        })
                    }

                    this.busyService.stop();

                    return arrayResult;
                });
        }

    }
}